import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import { convertEmptyStringToUndefinedFromObject } from '@/utils/object';

import type { OverChargeSearchFilters } from '../../types';

export interface GetOCClaimsListRequestParams extends OverChargeSearchFilters {}

type OCClaimsListAPIParams = Omit<GetOCClaimsListRequestParams, 'byAge' | 'StatusCodes'> & {
  StatusCodes: string;
};

export interface FetchOCClaimsListOptions {
  signal?: AbortSignal;
}

export const getOCClaimsListAPI = (params: OCClaimsListAPIParams, options: FetchOCClaimsListOptions = {}) => {
  return axiosInstance.request({
    method: 'get',
    params,
    signal: options.signal,
    url: `${API.OVERCHARGE_CLAIM}/GetClaimSearch`,
  });
};

export const fetchOCClaimsList = async (
  params: GetOCClaimsListRequestParams,
  options: FetchOCClaimsListOptions = {},
) => {
  const { byAge: _byAge, StatusCodes, ...rest } = params;
  const requestParams = {
    ...convertEmptyStringToUndefinedFromObject(rest),
    StatusCodes: StatusCodes ? StatusCodes.join(',') : '-1',
  } as OCClaimsListAPIParams;

  const response: AxiosResponse = await getOCClaimsListAPI(requestParams, options);
  return response.data;
};
